import { type App, computed, type ComputedRef, inject } from 'vue'
import type { CurrencyInput } from '@/graphql/api'
import { type RegionPlugin } from '@/plugins/region.ts'
import { type CurrencyPlugin } from '@/plugins/currency.ts'

const key = 'app.plugin.currency-input'

export function installCurrencyInputPlugin(
    app: App,
    regionPlugin: RegionPlugin,
    currencyPlugin: CurrencyPlugin
): ComputedRef<CurrencyInput> {
    const { regionCode } = regionPlugin
    const { currency } = currencyPlugin

    const input = computed(() => ({
        region: regionCode.value,
        currency: currency.value,
    }))

    app.provide(key, input)

    return input
}

export function useCurrencyInput(): ComputedRef<CurrencyInput> {
    return inject(key) as ComputedRef<CurrencyInput>
}
